<template>
  <router-view/>
</template>

<style>
#app {
  font-family: "Inter";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
* {
  border: 0;
  margin: 0;
}
</style>
